import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: '0px 1px 3px 0px #A6AFC366',
        fontSize: 11,
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: 'white',
        filter: 'drop-shadow(0px 1px 3px #A6AFC366)',
    },
}));

export { LightTooltip };
